import React from "react";

import { cn } from "~/components/ui/cn";

/**
 * Main loader component.
 */
export const Loader: React.FC<React.ComponentProps<"svg">> = ({
  className,
  ...props
}) => {
  return (
    <svg
      className={cn("animate-spin-fast text-green-900", className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <circle cx="16" cy="16" r="15" stroke="#ECECEC" strokeWidth="2" />
      <path
        d="M16 1C17.9698 1 19.9204 1.38799 21.7403 2.14181C23.5601 2.89563 25.2137 4.00052 26.6066 5.3934C27.9995 6.78628 29.1044 8.43987 29.8582 10.2598C30.612 12.0796 31 14.0302 31 16"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

Loader.displayName = "Loader";
